import PropTypes from 'prop-types';
import React from 'react';

import './radio-tabs.scss';

const RadioTabs = ({ name, label, options, value, onChange, disabled, error }) => {
  const isReadOnly = disabled || !onChange;

  return (
    <div className="radio-tabs">
      {label && <p className="radio-tabs__label">{label}</p>}

      <div
        className="radio-tabs__options"
        role="radiogroup"
        aria-label={typeof label === 'string' ? label : name}>
        {options.map((opt) => {
          const isSelected = value === opt.value;
          const Tag = isReadOnly ? 'div' : 'button';

          return (
            <Tag
              key={opt.value}
              type={isReadOnly ? undefined : 'button'}
              className={`radio-tabs__tab ${isSelected ? 'radio-tabs__tab--selected' : ''}`}
              role="radio"
              aria-checked={isSelected}
              onClick={isReadOnly ? undefined : () => onChange(opt.value)}
              data-testid={`radio-tab-${name}-${opt.value}`}>
              <span className="radio-tabs__dot-ring">
                {isSelected && <span className="radio-tabs__dot" />}
              </span>
              {opt.label}
            </Tag>
          );
        })}
      </div>

      {error && (
        <span className="radio-tabs__error" role="status">
          {error}
        </span>
      )}
    </div>
  );
};

RadioTabs.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.node,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired
    })
  ).isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  error: PropTypes.string
};

export { RadioTabs };
